"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [https://neo4j.com]
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var neo4j_driver_core_1 = require("neo4j-driver-core");
var connection_http_1 = __importDefault(require("./connection.http"));
var _a = neo4j_driver_core_1.internal.pool, Pool = _a.Pool, PoolConfig = _a.PoolConfig, Bookmarks = neo4j_driver_core_1.internal.bookmarks.Bookmarks, TxConfig = neo4j_driver_core_1.internal.txConfig.TxConfig, _b = neo4j_driver_core_1.internal.constants, ACCESS_MODE_READ = _b.ACCESS_MODE_READ, ACCESS_MODE_WRITE = _b.ACCESS_MODE_WRITE;
var AUTHENTICATION_ERRORS = [
    'Neo.ClientError.Security.CredentialsExpired',
    'Neo.ClientError.Security.Forbidden',
    'Neo.ClientError.Security.TokenExpired',
    'Neo.ClientError.Security.Unauthorized'
];
var HttpConnectionProvider = /** @class */ (function (_super) {
    __extends(HttpConnectionProvider, _super);
    function HttpConnectionProvider(config, _a) {
        var _b = _a === void 0 ? {
            newPool: function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                return new (Pool.bind.apply(Pool, __spreadArray([void 0], __read(params), false)))();
            },
            newHttpConnection: function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                return new (connection_http_1.default.bind.apply(connection_http_1.default, __spreadArray([void 0], __read(params), false)))();
            }
        } : _a, newPool = _b.newPool, newHttpConnection = _b.newHttpConnection;
        var _this = _super.call(this) || this;
        _this._id = config.id;
        _this._log = config.log;
        _this._address = config.address;
        _this._scheme = config.scheme;
        _this._authTokenManager = config.authTokenManager;
        _this._config = config.config;
        _this._openConnections = {};
        _this._queryEndpoint = "".concat(_this._scheme, "://").concat(_this._address.asHostPort(), "/db/{databaseName}/query/v2");
        _this._newHttpConnection = newHttpConnection;
        _this._pool = newPool({
            create: _this._createConnection.bind(_this),
            destroy: _this._destroyConnection.bind(_this),
            validateOnAcquire: _this._validateConnectionOnAcquire.bind(_this),
            config: PoolConfig.fromDriverConfig(config.config),
            log: _this._log
        });
        return _this;
    }
    HttpConnectionProvider.prototype.acquireConnection = function (param) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._pool.acquire({ auth: param === null || param === void 0 ? void 0 : param.auth, queryEndpoint: this._queryEndpoint }, this._address)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpConnectionProvider.prototype.verifyConnectivityAndGetServerInfo = function (param) {
        return __awaiter(this, void 0, void 0, function () {
            var discoveryInfo, connection;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, connection_http_1.default.discover({ scheme: this._scheme, address: this._address })];
                    case 1:
                        discoveryInfo = _a.sent();
                        return [4 /*yield*/, this._pool.acquire({ queryEndpoint: this._queryEndpoint }, this._address)];
                    case 2:
                        connection = _a.sent();
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, , 5, 7]);
                        return [4 /*yield*/, run(connection, param)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, new neo4j_driver_core_1.ServerInfo({
                                address: this._address.asHostPort(),
                                version: discoveryInfo.version
                            }, parseFloat(discoveryInfo.version))];
                    case 5: return [4 /*yield*/, connection.release()];
                    case 6:
                        _a.sent();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnectionProvider.prototype.verifyAuthentication = function (param) {
        return __awaiter(this, void 0, void 0, function () {
            var connection, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.acquireConnection(__assign(__assign({}, param), { bookmarks: Bookmarks.empty() }))];
                    case 1:
                        connection = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, 5, 7]);
                        return [4 /*yield*/, run(connection, param)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 4:
                        error_1 = _a.sent();
                        if (AUTHENTICATION_ERRORS.includes(error_1.code)) {
                            return [2 /*return*/, false];
                        }
                        throw error_1;
                    case 5: return [4 /*yield*/, connection.release()];
                    case 6:
                        _a.sent();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnectionProvider.prototype.supportsMultiDb = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, true];
            });
        });
    };
    HttpConnectionProvider.prototype.supportsSessionAuth = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, true];
            });
        });
    };
    HttpConnectionProvider.prototype.supportsUserImpersonation = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, true];
            });
        });
    };
    HttpConnectionProvider.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._pool.close()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, Promise.all(Object.values(this._openConnections).map(function (c) { return c.close(); }))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HttpConnectionProvider.prototype._createConnection = function (context, address, release) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var auth, _b, connection;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!((_a = context.auth) !== null && _a !== void 0)) return [3 /*break*/, 1];
                        _b = _a;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this._authTokenManager.getToken()];
                    case 2:
                        _b = _c.sent();
                        _c.label = 3;
                    case 3:
                        auth = _b;
                        connection = this._newHttpConnection({
                            release: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, release(address, connection)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            }); }); },
                            auth: auth,
                            address: address,
                            queryEndpoint: context.queryEndpoint,
                            config: this._config,
                            logger: this._log,
                            errorHandler: function (error) {
                                if (error == null || typeof error.code !== 'string' || !error.code.startsWith('Neo.ClientError.Security.') || (context === null || context === void 0 ? void 0 : context.auth) != null) {
                                    if (error != null && error.code === 'SERVICE_UNAVAILABLE') {
                                        _this._queryEndpoint = undefined;
                                    }
                                    return error;
                                }
                                var handled = _this._authTokenManager.handleSecurityException(auth, error.code);
                                if (handled) {
                                    error.retriable = true;
                                }
                                return error;
                            }
                        });
                        this._openConnections[connection.id] = connection;
                        return [2 /*return*/, connection];
                }
            });
        });
    };
    HttpConnectionProvider.prototype._validateConnectionOnAcquire = function (context, conn) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c, error_2;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 4, , 5]);
                        conn.queryEndpoint = context.queryEndpoint;
                        _b = conn;
                        if (!((_a = context.auth) !== null && _a !== void 0)) return [3 /*break*/, 1];
                        _c = _a;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this._authTokenManager.getToken()];
                    case 2:
                        _c = _d.sent();
                        _d.label = 3;
                    case 3:
                        _b.auth = _c;
                        return [2 /*return*/, true];
                    case 4:
                        error_2 = _d.sent();
                        this._log.debug("The connection ".concat(conn.id, " is not valid because of an error ").concat(error_2.code, " '").concat(error_2.message, "'"));
                        return [2 /*return*/, false];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnectionProvider.prototype._destroyConnection = function (conn) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        delete this._openConnections[conn.id];
                        return [4 /*yield*/, conn.close()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return HttpConnectionProvider;
}(neo4j_driver_core_1.ConnectionProvider));
exports.default = HttpConnectionProvider;
/**
 * Execute a query and reports possible errors
 * @param connection
 * @param config
 * @returns Promise of correct execution
 */
function run(connection, config) {
    return new Promise(function (resolve, reject) {
        connection.run('CALL db.ping()', {}, {
            database: config === null || config === void 0 ? void 0 : config.database, mode: config === null || config === void 0 ? void 0 : config.accessMode, fetchSize: 200, reactive: false, bookmarks: Bookmarks.empty(), highRecordWatermark: 10, lowRecordWatermark: 0, txConfig: TxConfig.empty()
        })
            .subscribe({
            onCompleted: function () {
                resolve();
            },
            onError: function (error) {
                reject(error);
            }
        });
    });
}
